interface FormatParameters {
  showCurrency?: boolean;
}

export const formatAmount = (
  value?: number | null,
  { showCurrency = true }: FormatParameters = {}
) => {
  if (value === null || value === undefined) {
    return '—';
  }

  return `${value.toLocaleString('ru-RU')}${showCurrency ? '' : ''}`.trim();
};
